import React from "react";
import "../../assets/css/serviciosPrincipales.css"; 

const ServiciosGeneralesCard = ({ titulo, subtitulo, descripcion, imagen }) => (
  <div
    className="serviciosCard"
    style={{
      backgroundImage: `url(${imagen})`,
    }}
  >
    <h4>{titulo}</h4>
    <h2>{subtitulo}</h2>
    <div className="linea-titulo"></div>
    <div className="contenidoServiciosCard">
      <div className="linea"></div>
      <h3>
        {titulo} {subtitulo}
      </h3>
      <p>{descripcion}</p>
    </div>
  </div>
);

export default ServiciosGeneralesCard;
